<section id="about-us">
    <div class="content-wrapper">
        <div class="content-body">
            <div class="row">
                <div class="col-12">
                    <div class="container">
                        <div class="card">
                            <div class="row text-center mt-1">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h2 class="font-weight-light shadow-bottom-light p-1">About Us</h2>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <!--<div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <img src="https://picsum.photos/200/300" style="width: 100%; height: 300px"/>
                                    </div>-->
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <p class="card-text">
                                            IEC University has surged forward in the area of Emerging Technologies both
                                            in
                                            Engineering & Arts; you will find that we are the first Institutions
                                            which have
                                            raced upwards leaving behind Traditional Engineering & Arts since our
                                            primary
                                            focus is
                                            to empower our students first by being abreast if not at par with the
                                            current
                                            technology! The entire world of careers has dramatically changed and St.
                                            Mary’s
                                            Group
                                            has, and we invite you to Visit us, Compare us with others, then, you will
                                            be
                                            ours! We
                                            are proud of the accomplishments of our students/alumni who are University
                                            Gold
                                            Medalists, IPS Officers, Celebrities, most of all, our students have secured
                                            the
                                            highest
                                            packages!
                                        </p>
                                        <p class="card-text">
                                            IEC University Always Preaches And Practices “Student- First Approach”. It
                                            Is
                                            In- Fact The
                                            Core Strength Of IEC University And Is A Unique Concept That
                                            Creates A
                                            Strong Bond Between The Management, Parents And The Students. It Provides
                                            Important
                                            Inputs To The Administrator For Excellence In Governance.
                                        </p>
                                        <p class="card-text">
                                            Accessibility Is Not Only The Approach, It Is A Commitment By The Management
                                            To
                                            Provide 24/7 Access To Infrastructure And Facilities For The Well-Being,
                                            Improvement And Career Progress Of The Student.
                                        </p>
                                        <p class="card-text">
                                            Transparency Is About The Interaction With Both Parents And Students, Making
                                            Each Stakeholder On The Improvement And Continuous Development Of Students’
                                            Aptitude And Attitude.
                                        </p>
                                        <p class="card-text">
                                            Accountability Is an Assurance To Comply With The Rules And Regulations, A
                                            Promise To The Parents To Provide An Overall Development To Their Ward’s
                                            Future.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
